import { render, staticRenderFns } from "./Bangbangxunzhu.vue?vue&type=template&id=98786f90&scoped=true&"
import script from "./Bangbangxunzhu.vue?vue&type=script&lang=js&"
export * from "./Bangbangxunzhu.vue?vue&type=script&lang=js&"
import style0 from "./Bangbangxunzhu.vue?vue&type=style&index=0&id=98786f90&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98786f90",
  null
  
)

export default component.exports